import { render, staticRenderFns } from "./Cocktails.vue?vue&type=template&id=722b4607&scoped=true&"
import script from "./Cocktails.vue?vue&type=script&lang=js&"
export * from "./Cocktails.vue?vue&type=script&lang=js&"
import style0 from "./Cocktails.vue?vue&type=style&index=0&id=722b4607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b4607",
  null
  
)

export default component.exports